Application.Improvements = {
    ui: {
        container: '.js-improvements',
        next: '.js-form__next',
        back: '.js-form__back',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // actions
        $(this.ui.back).add(this.ui.next).click(function(e){
            self.showLoader();
        });

    },
    showLoader: function(){

        $('body').addClass('loading');

    }
};